import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store';
import { GAME_DB } from '../../db/game';
import { setGame } from '../../store/slices/rallyGame';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { getGameState } from '../../api/game-mode/game';
import { useTranslation } from 'react-i18next';
import { API_ERRORS } from '../../app.config.vars/errorCodes';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const useFetchGameState = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    useEffect(() => {
        const fetchGameState = async () => {
            const gameState = await getGameState();
            if (gameState.data) {
                await GAME_DB.UPDATE.gameState(gameState.data);
                dispatch(setGame(gameState.data));
            }
            else if (gameState.error?.code === API_ERRORS.noInternet) {
                const localGameState = await GAME_DB.GET.game();
                if (localGameState) {
                    dispatch(setGame(localGameState));
                }
                else {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
            }
            else {
                console.log('No access to play game');
                navigate(APP_ROUTES.rallies);
            }
        };
        fetchGameState();
    }, [i18n.language]);
};
export default useFetchGameState;
